import styled from '@emotion/styled'

import { ReactComponent as BillyThinking } from '../../../../assets/images/billy-thinking.svg'

export const DuplicateBillIllustration = styled(BillyThinking)`
  position: absolute;
  top: -30px;
  right: 70px;
`
